import Model, { attr } from '@ember-data/model';

type GoalType =
  | 'no_goal'
  | 'rolling'
  | 'rolling_exclude_pledges'
  | 'rolling_no_goal'
  | 'annual'
  | 'ytd'
  | 'total'
  | 'total_and_expecting'
  | 'global_interaction'
  | 'resonate_global_mission'
  | 'cef';

export default class GoalModel extends Model {
  @attr('string') declare goalType: GoalType;
  @attr('number') declare goalAmount: number;
  @attr('string') declare fundId: string;
  @attr() goalSettings: any;
  @attr() goalData: any | GoalDataTotalAndExpecting | GoalDataYtd;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    goal: GoalModel;
  }
}

export interface GoalDataTotalAndExpecting {
  start_date: string;
  goal_date: string;
  given_amount: number;
  given_percent: number;
  expected_amount: number;
  expected_percent: number;
  total_amount: number;
  total_percent: number;
  left_amount: number;
  left_percent: number;
  running_given_by_month: {
    month: string;
    total_given: number;
  }[];
  pledges: {
    expected: {
      pledge_id: string;
      expected_amount: number;
      expected_gifts_count: number;
    }[];
    overdue: {
      pledge_id: string;
      expected_amount: number;
      expected_gifts_count: number;
    }[];
    fulfilled: {
      pledge_id: string;
    }[];
  };
}

export interface GoalDataYtd {
  start_date: string;
  end_date: string;
  expected_amount: number;
  expected_percent: number;
  expected_from_date: string;
  expected_to_date: string;
  expected_number_monmths: 4;
  given_amount: number;
  given_percent: number;
  given_to_date: string;
  left_amount: number;
  left_percent: number;
  monthly_goal: number;
  overdue_amount: number;
  overdue_percent: number;
  recurring_pledges_amount: number;
  total_amount: number;
  total_percent: number;
  monthly_gifts: { month: string; amount: number }[];
  young_life?: GoalDataYtdYoungLife;
}

export interface GoalDataYtdYoungLife {
  campaign_goals_total: number;
  campaign_goals_total_percent: number;
  campaign_goals_left_amount: number;
  campaign_goals_left_percent: number;
  monthly_pledges_amount: number;
}
